export default "__VITE_ASSET__ca148422__"